import request from '@/utils/request';
//查询礼品列表
export function getQueryOrderPage(param) {
  return request('/activityPoints/queryOrderPage', {
    method: 'POST',
    data: param,
  });
}

//删除礼品
export const deleteGift = (data) => {
  return request('/activityPoints/deleteGift', {
    method: 'POST',
    data,
  });
};
